import { FC } from "react";
import ImageSprite from "../../../../assets/components/ImageSprite/ImageSprite";
import CheckImg from "../Img/check.svg";
import { IoloLicenseInfo } from "../../../../redux/RTKQuery/api";

type Props = {
    info: IoloLicenseInfo | undefined;
};

type StatusColor = "green" | "yellow" | "red" | "blue" | "grey";

const IoloLicenseKeysInformPanel: FC<Props> = ({ info }) => {
    if (!info) {
        return (
            <div className="row__item">
                <div className="row__data">No Iolo info available</div>
            </div>
        );
    }

    const { sku, userId, disabled, installationCount, installationMax } = info;

    const installationsColor: StatusColor =
        installationMax && (installationCount ?? 0) >= installationMax
            ? "red"
            : "green";

    return (
        <>
            <div className="row__item">
                <div className="row__label">
                    <span className="status_color blue">SKU:</span>
                </div>
                <div className="row__data">
                    <span className="status_color blue">{sku ?? "—"}</span>
                </div>
            </div>

            <div className="row__item">
                <div className="row__label">User ID:</div>
                <div className="row__data">{userId ?? "—"}</div>
            </div>

            <div className="row__item">
                <div className="row__label">
                    <span className={`status_color ${installationsColor}`}>
                        Installations:
                    </span>
                </div>
                <div className="row__data">
                    <span className={`status_color ${installationsColor}`}>
                        {installationCount ?? 0} / {installationMax ?? 0}
                    </span>
                </div>
            </div>

            <div className="row__item row__item_migrated">
                <div className="row__label">Disabled:</div>
                <div className="row__data">
                    <ImageSprite
                        iconSprite={`${CheckImg}${
                            disabled ? "#checked" : "#unchecked"
                        }`}
                    />
                </div>
            </div>
        </>
    );
};

export default IoloLicenseKeysInformPanel;
